/**
 * @ipc/admin-ui · shared/api/query-client — QueryClient TanStack Query.
 * staleTime 30s (данные панели живые, но не дёргаем сеть на каждый фокус),
 * retry 1 (одна повторная попытка на транзиентную сетевую ошибку),
 * refetchOnWindowFocus false (служебная панель — без фонового рефетча при фокусе).
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // 4xx (кроме 429) не ретраим — это не транзиентная ошибка.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500 && error.status !== 429) {
            return false;
          }
          return failureCount < 1;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
